import { Spinner } from "react-bootstrap";
import { Box } from "@material-ui/core";
import config from "../../config";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { useState, useEffect, useCallback, useRef } from "react";
//
import {
  Card,
  Dropdown,
  Select,
  Table,
  Button,
  Typography,
  DatePicker,
  Input,
  Alert,
} from "antd";
import CryptoJS from "crypto-js/aes";
import { groupBy, sumBy } from "lodash";
import { Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import moment from "moment";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import CustomTable from "../table";
import { useNavigate } from "react-router-dom";
import Loader from "../loader";
import dayjs from "dayjs";
import { useAccess } from "../../provider/AccessProvider";
import { CUSTOMERACCESS } from "../../utils/constant";
const RangePicker = DatePicker.RangePicker;

const CustomerManagement = (props) => {
  const [aliasModal, setAliasModal] = useState(false);
  const [updatedAlias, setUpdatedAlias] = useState("");
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const rangeRef = useRef();
  const [customDate, setCustomDate] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [specificValue, setSpecificValue] = useState("");
  const menu = (data) => {
    // console.log("Bill dara", data);
    const encryptData = CryptoJS.encrypt(
      data.customerPhoneNumber,
      process.env.REACT_APP_CRYPTO_KEY
    )
      .toString()
      .replace(/\+/g, "p1L2u3S")
      .replace(/\//g, "s1L2a3S4h")
      .replace(/=/g, "e1Q2u3A4l");

    return (
      <Menu>
        <Menu.Item
          style={{
            width: "150px",
          }}
          onClick={() => {
            const isAccess = access.customerViewAllBills();
            if (!isAccess) {
              return;
            }
            navigate({
              pathname: `/dashboard/customer-management/bill-history`,
              search: `?id=${encryptData}`,
            });
          }}
          key="bill"
        >
          Bills
        </Menu.Item>
        <Menu.Item
          style={{
            width: "150px",
          }}
          onClick={() => {
            const isAccess = access.outstanding();
            if (!isAccess) {
              return;
            }
            navigate({
              pathname: `/dashboard/customer-management/outstandings`,
              search: `?id=${encryptData}`,
            });
          }}
          key="outstanding"
        >
          Outstanding
        </Menu.Item>
        {data.alias && (
          <Menu.Item
            style={{
              width: "150px",
            }}
            onClick={() => {
              const isAccess = access.updateAlias();
              if (!isAccess) {
                return;
              }
              setAlias(data.alias);
              setUpdatedAlias(data.alias);
              setAliasModal(true);
            }}
            key="view"
          >
            Edit Alias
          </Menu.Item>
        )}
      </Menu>
    );
  };
  useEffect(() => {
    function keydownHandler(event) {
      // event.preventDefault();
      // event.stopPropagation();
      if (event.altKey && event.keyCode == 83) {
        // Search Customer (S)
        document.getElementById("customerNumber").focus();
      }
    }
    document.addEventListener("keydown", keydownHandler);
    return () => {
      window.removeEventListener("keydown", keydownHandler);
    };
  }, []);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const employeeId = useSelector((state) => state.shopDetails.empId);
  const [customerMobileNumber, setCustomerMobileNumber] = useState("");
  const [bills, setBills] = useState([]);
  const [billData, setBillData] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [invoiceModal, setInvoiceModal] = useState(false);
  const [pdf, setPdf] = useState("");
  const [pdfModal, setPdfModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [alias, setAlias] = useState();
  const [dateValue, setDateValue] = useState(7);
  const [dateNextValue, setDateNextValue] = useState(7);
  const [date, setDate] = useState({
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  });
  const [billDataOfCustomer, setBillDataOfCustomer] = useState([]);
  const access = useAccess(CUSTOMERACCESS);

  const getBillDataByCustomer = async (value) => {
    try {
      const res = await fetch(`${config.newApiGateway}/bill/getBillDetails`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopId,
          type: "bill",
          action: "specificCustomer",
          customerPhoneNumber: country.dialCode + value,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (data?.status) {
        const value = {
          numberOfBills: data.length,
          customerName: data.bills[0].customerName,
          customerPhoneNumber: data.bills[0].customerPhoneNumber,
          averagePurchase:
            parseFloat(totalBillAmount(data.bills)) / data.length,
          balanceAmount: totalBalanceAmount(data.bills),
          amountPaid: totalBillAmount(data.bills),
          alias: data.bills.find((i) => {
            let result;
            if ("uniqueIdentity" in i) {
              result = i;
            }
            return result;
          })?.uniqueIdentity,
        };
        setBillDataOfCustomer([value]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getBillData = async (date) => {
    if (!shopId && !employeeId) return;
    let start_date = dayjs()
      .subtract(dateNextValue - 1, "days")
      .format("YYYY-MM-DD");
    let end_Date = dayjs(start_date)
      .add(dateValue - 1, "days")
      .format("YYYY-MM-DD");
    if (dateValue === "custom") {
      start_date = date.startDate;
      end_Date = date.endDate;
    }
    await Promise.all([
      fetch(`${config.newApiGateway}/bill/getBillDetails`, {
        method: "POST",
        body: JSON.stringify({
          userId: shopId,
          type: "bill",
          // employeeId: employeeId ? employeeId : "",
          startDate: start_date,
          endDate: end_Date,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data !== undefined) {
          if (data.limitExceeds && data.status) {
            try {
              var s3Bills = await fetch(data.bills);
              s3Bills = await s3Bills.json();
              setBills((prev) => [...prev, ...s3Bills]);
              return;
            } catch (err) {
              alert("Failed to fetch analytics.");
              return;
            }
          }
          const filteredBillData = data.bills.filter((i) => {
            return i.type === "bill";
          });
          // setBills((prev) => [...prev, ...filteredBillData]);
          setBills([...bills, ...filteredBillData]);
          // setBills(filteredBillData);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
        setTableLoading(false);
        setLoading(false);
      });
  };

  const totalBillAmount = (bills) => {
    const result = sumBy(bills, (i) => {
      return parseFloat(i.amountPaid) || 0;
    });
    return result;
  };
  const totalBalanceAmount = (bills) => {
    let result = 0;
    bills.forEach((i) => {
      if (i.billCancelled) {
        result += 0;
      } else {
        result +=
          parseFloat(i.balanceAmount) > 0 ? parseFloat(i.balanceAmount) : 0;
      }
    });
    return result;
  };

  const processCustomerBillData = useCallback(() => {
    if (bills) {
      const groupByCustomerNo = groupBy(bills, "customerPhoneNumber");
      const keys = Object.keys(groupByCustomerNo);
      const result = keys.map((item) => {
        console.log("groupByCustomerNo", item, groupByCustomerNo[item]);
        const billLength = groupByCustomerNo[item].length;
        return {
          numberOfBills: billLength,
          customerName: groupByCustomerNo[item][0].customerName.toLowerCase(),
          customerPhoneNumber: groupByCustomerNo[item][0].customerPhoneNumber,
          averagePurchase:
            parseFloat(totalBillAmount(groupByCustomerNo[item])) / billLength,
          balanceAmount: totalBalanceAmount(groupByCustomerNo[item]),
          amountPaid: totalBillAmount(groupByCustomerNo[item]),
          alias: groupByCustomerNo[item].find((i) => {
            let result;
            if ("uniqueIdentity" in i) {
              result = i;
            }
            return result;
          })?.uniqueIdentity,
        };
      });

      const filteredData = result.filter((i) => i.customerPhoneNumber !== "NA");
      const sorted = filteredData.sort(function (a, b) {
        return a.customerName === b.customerName ? 0 : a < b ? -1 : 1;
      });

      console.log("sorted", sorted);

      setBillData(filteredData);
    }
  }, [bills]);

  useEffect(() => {
    processCustomerBillData();
  }, [processCustomerBillData]);

  useEffect(() => {
    if (shopId === "" && !shopId) return;
    if (dateValue === "custom") {
      setBillData([]);
      getBillData(date);
    } else if (dateValue !== "custom") {
      getBillData(dateNextValue);
    }
  }, [shopId, dateNextValue, dateValue, date]);

  const handleDateRange = (v) => {
    if (v === null) {
      //setSelectedValue("today");
      setDate({
        startDate: dayjs().format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
      });
      setCustomDate([]);
    } else {
      setCustomDate(v);
      const dateValue = v.map((i) => {
        return dayjs(i).format("YYYY-MM-DD");
      });
      setDate({
        startDate: dateValue[0],
        endDate: dateValue[1],
      });
    }
  };

  const getInvoicePDF = async (billId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/bill/getInvoice`, {
        method: "POST",
        body: JSON.stringify({
          billId: billId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        const arr = new Uint8Array(data.Body.data);
        const blob = new Blob([arr], { type: "application/pdf" });
        const file = URL.createObjectURL(blob);
        setPdf(file);
        setInvoiceModal(false);
        setPdfModal(true);
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const handleAliasChange = (event) => {
    const value = event.target.value;
    setUpdatedAlias(value);
  };
  const handleSaveAlice = async () => {
    if (!updatedAlias) return alert("Please enter alias");

    const isExist = billData.some(
      (i) => i.alias?.toLowerCase() === updatedAlias.toLowerCase()
    );
    if (isExist) {
      return alert("Already Exists");
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config.newApiGateway}/alias/updateAlias`,
        {
          method: "POST",
          body: JSON.stringify({
            uniqueIdentity: alias,
            newUniqueIdentity: updatedAlias,
            shopId: shopId,
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      const res = await response.json();
      console.log("res", res);
      if (res.code === "SUCCESS") {
        const updatedBillData = billData.map((i) => {
          if (i.alias === alias) {
            return {
              ...i,
              alias: updatedAlias,
            };
          }
          return i;
        });
        setBillData(updatedBillData);
        return alert(res.message);
      }
    } catch (err) {
      alert("Error while updating Alias!!!");
    } finally {
      setIsLoading(false);
      setAliasModal(false);
    }
  };

  const handleDateChange = (val) => {
    setDateValue(val);
    setTableLoading(true);
    setBills([]);
    if (val !== "custom" && val !== "specific") {
      setDateNextValue(val);
    }
  };

  const handleDate = () => {
    setDateNextValue((prev) => prev + dateValue);
    setTableLoading(true);
  };

  const tableColumns = [
    {
      title: "Customer Name",
      dataIndex: "customerName",
      defaultSort: "asc",
      defaultGroupSort: "desc",
      cellStyle: {
        textTransform: "capitalize",
      },
    },
    {
      title: "Mobile Number",
      dataIndex: "customerPhoneNumber",
    },
    {
      title: "Number of bills",
      dataIndex: "numberOfBills",
    },
    {
      title: `Total bill amount(${country.CurrencySymbol})`,
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.amountPaid)}</div>;
      },
    },
    {
      title: `Average Purchase(${country.CurrencySymbol})`,
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.averagePurchase)}</div>;
      },
    },
    {
      title: `Outstanding(${country.CurrencySymbol})`,
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.balanceAmount)}</div>;
      },
    },
    {
      title: "Alias",
      render: (rowData) => {
        return <div>{rowData.alias ? rowData.alias : "-"}</div>;
      },
    },
    {
      title: "Actions",
      render: (data) => {
        return (
          <Dropdown
            getPopupContainer={(el) => el.parentNode}
            overlay={menu(data)}
            placement="left"
            arrow
          >
            <EllipsisOutlined
              style={{
                fontSize: "2rem",
                transform: "rotate(90deg)",
                cursor: "pointer",
                padding: "1rem",
              }}
            />
          </Dropdown>
        );
      },
    },
  ];

  const exportHead = [
    "Customer Name",
    "Mobile Number",
    "Number of bills",
    "Total bill amount",
    "Average Purchase",
    "Outstanding",
    "Alias",
  ];
  const exportValue = [
    "customerName",
    "customerPhoneNumber",
    "numberOfBills",
    "amountPaid",
    "averagePurchase",
    "balanceAmount",
    "alias",
  ];

  const handleSearch = (value) => {
    if (!value) {
      return alert("Please enter customer number");
    } else if (value.length !== country.numberLimit) {
      return alert("Please enter valid number");
    }
    setLoading(true);
    setSpecificValue(value);
    getBillDataByCustomer(value);
  };

  const handleReset = () => {
    setDateValue(7);
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  return (
    <>
      <div>
        {isLoading && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <Loader size={56} />
          </Box>
        )}
        {!isLoading && (
          <>
            {!access.customer(false) ? (
              <Alert
                style={{
                  padding: "20px",
                  textAlign: "center",
                }}
                message="You don't have access, Please contact your administrator to request the appropriate access."
                type="error"
              />
            ) : (
              <>
                <Card
                  style={{
                    marginBottom: 20,
                  }}
                >
                  {dateValue !== "custom" && (
                    <Select
                      value={dateValue}
                      onChange={handleDateChange}
                      defaultValue={7}
                      style={{
                        width: "200px",
                      }}
                      disabled={tableLoading}
                    >
                      <Select.Option value={7}>Last 7 days</Select.Option>
                      <Select.Option value={30}>Last 30 days</Select.Option>
                      <Select.Option value="custom">Custom Date</Select.Option>
                      <Select.Option value="specific">
                        Search specific customer
                      </Select.Option>
                    </Select>
                  )}
                  {dateValue === "custom" && (
                    <RangePicker
                      ref={rangeRef}
                      value={customDate}
                      onChange={handleDateRange}
                      disabledDate={disabledDate}
                      open={customDate?.length === 2 ? false : true}
                    />
                  )}
                  {dateValue === "specific" && (
                    <Input.Search
                      style={{
                        marginLeft: "8px",
                        width: "250px",
                      }}
                      onSearch={handleSearch}
                      placeholder="Enter customer no"
                      enterButton="Search"
                      prefix={country.dialCode}
                    />
                  )}
                  {!!(dateValue !== "custom" && dateValue !== "specific") && (
                    <Button
                      size="medium"
                      type="primary"
                      style={{
                        marginLeft: "8px",
                      }}
                      disabled={tableLoading}
                      onClick={handleDate}
                    >
                      +{dateValue} Days
                    </Button>
                  )}
                  {!!(dateValue === "custom" || dateValue === "specific") && (
                    <Button
                      type="primary"
                      style={{ marginLeft: "8px" }}
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                  )}
                </Card>
                <CustomTable
                  columns={tableColumns}
                  data={
                    dateValue === "specific" ? billDataOfCustomer : billData
                  }
                  title={
                    <div>
                      Customer Details
                      {!!(
                        dateValue !== "specific" && dateValue !== "custom"
                      ) && (
                        <Typography.Text type="secondary">
                          (Last {dateNextValue}days)
                        </Typography.Text>
                      )}
                      {dateValue === "custom" && (
                        <Typography.Text type="secondary">
                          ({date.startDate} - {date.endDate})
                        </Typography.Text>
                      )}
                    </div>
                  }
                  style={{
                    minHeight: "calc(100vh - 365px)",
                  }}
                  emptyContainerStyle={{
                    minHeight: "calc(100vh - 300px)",
                  }}
                  csvAccessKey="customerCsvExport"
                  loading={loading}
                  excelExport={true}
                  exportHead={exportHead}
                  exportValue={exportValue}
                />
                <div className="cm-container">
                  <div className="cm-table"></div>
                </div>
              </>
            )}
          </>
        )}
        <Modal
          show={aliasModal}
          onHide={() => setAliasModal(false)}
          size="sm"
          centered
        >
          <Modal.Body>
            <h5>Update Alias</h5>
            <Input
              style={{
                width: "100%",
              }}
              maxLength={10}
              value={updatedAlias}
              onChange={handleAliasChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger-outline"
              onClick={() => setAliasModal(false)}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleSaveAlice}>
              Save
              <Spinner
                size="sm"
                color="#fff"
                style={{
                  marginLeft: "8px",
                }}
              />
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={invoiceModal}
          onHide={() => setInvoiceModal(false)}
          dialogClassName="custom-invoice-modal"
        >
          <Modal.Body>
            <h2>Customer Details</h2>
            {invoiceDetails[0] !== undefined && (
              <div>
                <div>
                  <h5>Name: {invoiceDetails[0].customerName}</h5>
                  <h6>
                    Mobile Number: {invoiceDetails[0].customerPhoneNumber}
                  </h6>
                </div>
                <div>
                  <Table
                    columns={[
                      {
                        title: "Date",
                        dataIndex: "billingDate",
                        key: "billingDate",
                      },
                      {
                        title: "Invoice number",
                        dataIndex: "invoiceNumber",
                        key: "invoiceNumber",
                        defaultSort: "desc",
                      },
                      {
                        title: `Bill Amount(${country.CurrencySymbol})`,
                        dataIndex: "amountPaid",
                        key: "amountPaid",
                      },
                      {
                        title: "Actions",
                        render: (data) => {
                          return (
                            <Button
                              onClick={() => {
                                getInvoicePDF(data.billId);
                              }}
                            >
                              View
                            </Button>
                          );
                        },
                      },
                    ]}
                    dataSource={invoiceDetails}
                    title={() => <h4>Bill History</h4>}
                  />
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setInvoiceModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
        {pdfModal && (
          <Modal
            dialogClassName="custom-pdf-modal"
            show={pdfModal}
            onHide={() => {
              setPdfModal(false);
              setInvoiceModal(true);
            }}
          >
            <Modal.Body>
              <div style={{ height: "200px !important" }}>
                <embed
                  src={pdf}
                  style={{ height: "580px", width: "500px" }}
                  type="application/pdf"
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={() => {
                  setPdfModal(false);
                  setInvoiceModal(true);
                }}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </>
  );
};
export default CustomerManagement;
